import { render, staticRenderFns } from "./newFormSerie.vue?vue&type=template&id=5019e5a9&scoped=true"
import script from "./newFormSerie.vue?vue&type=script&lang=js"
export * from "./newFormSerie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5019e5a9",
  null
  
)

export default component.exports